import { Link } from "wouter";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight } from "lucide-react";
import { FunnelEntry } from "@/data/funnels";

interface FunnelIndexCardProps {
  funnel: FunnelEntry;
}

export function FunnelIndexCard({ funnel }: FunnelIndexCardProps) {
  return (
    <div
      className="group bg-card rounded-xl border border-border border-t-4 border-t-teal-600 shadow-sm hover:shadow-md transition-all"
      data-testid={`card-funnel-${funnel.id}`}
    >
      <div className="p-8 space-y-6">
        <div className="flex items-start justify-between gap-4">
          <h3 className="text-2xl font-serif font-medium text-foreground">
            {funnel.title}
          </h3>
          {funnel.badge && (
            <Badge variant="secondary" className="shrink-0">
              {funnel.badge}
            </Badge>
          )}
        </div>

        <p className="text-muted-foreground leading-relaxed">
          {funnel.description}
        </p>

        <ul className="space-y-3">
          {funnel.features.map((feature, i) => (
            <li key={i} className="flex items-start gap-3">
              <Check className="w-5 h-5 text-teal-700 shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{feature}</span>
            </li>
          ))}
        </ul>

        <div className="pt-4">
          <Link href={funnel.href}>
            <Button
              className="w-full bg-teal-700 hover:bg-teal-800 text-white border-teal-800"
              data-testid={`button-begin-funnel-${funnel.id}`}
            >
              Begin Prototype <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
